import {match} from 'ts-pattern';

import {CustomerAdvancedSearchResultResponseBody} from '@dms/api/customer';

import {TestIdProps} from 'shared/web';

import {CustomerSearchRow} from '../utils/getCustomerSearchRows';
import {BusinessContactResultRow} from './BusinessContactResultRow';
import {BusinessResultRow} from './BusinessResultRow';
import {NaturalPersonResultRow} from './NaturalPersonResultRow';

interface CustomerSearchResultItemProps extends TestIdProps {
  row: CustomerSearchRow;
  onSelect: (customer: CustomerAdvancedSearchResultResponseBody, contactId?: string) => void;
  /** Hides the primary-contact line on customer-level rows (used when only customers are shown). */
  hidePrimaryContact?: boolean;
}

export function CustomerSearchResultItem(props: CustomerSearchResultItemProps) {
  return match(props.row)
    .with({kind: 'naturalPerson'}, (row) => (
      <NaturalPersonResultRow
        customer={row.customer}
        onSelect={props.onSelect}
        hidePrimaryContact={props.hidePrimaryContact}
        data-testid={props['data-testid']}
      />
    ))
    .with({kind: 'business'}, (row) => (
      <BusinessResultRow
        customer={row.customer}
        onSelect={props.onSelect}
        hidePrimaryContact={props.hidePrimaryContact}
        data-testid={props['data-testid']}
      />
    ))
    .with({kind: 'businessContact'}, (row) => (
      <BusinessContactResultRow
        customer={row.customer}
        contact={row.contact}
        onSelect={props.onSelect}
        data-testid={props['data-testid']}
      />
    ))
    .exhaustive();
}
